import React, { memo, forwardRef } from "react";
const SvgNegation = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M8 13a1 1 0 011-1h14a1 1 0 011 1v7a1 1 0 11-2 0v-6H9a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgNegation.displayName = "SvgNegation";
const MemoForwardRef = memo(SvgNegation);
export default MemoForwardRef;
